export default function randEnumValue<T>(enumObj: T): T[keyof T] {
  const enumValues = Object.values(enumObj as { [key: string]: T[keyof T] })
  const index = Math.floor(Math.random() * enumValues.length)

  return enumValues[index] as T[keyof T]
}
